import React from 'react';
import ReactPaginate from 'react-paginate';
import { perPage } from '../../config';

const Paginator = (props) => {
  const pageSize = props.pageSize || perPage;
  const pageCount = Math.ceil(props.count/pageSize);

  if (pageCount > 1) {
    return <div className='my-2'><ReactPaginate
            forcePage={ props.forcePage }
            previousLabel={ '<<' }
            nextLabel={ '>>' }
            breakLabel={ '...' }
            breakClassName={ 'break-me' }
            pageCount={ pageCount }
            marginPagesDisplayed={ 2 }
            pageRangeDisplayed={ 5 }
            onPageChange={ props.onPageChange }
            containerClassName={ 'pagination' }
            subContainerClassName={ 'pages pagination' }
            activeClassName={ 'active' }
          /></div>
  }
  return <></>
};
export default Paginator;
